import React, { useState, useEffect } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../../Navbar";
import Header from "../../Header";
import baseUrl from "../../BaseUrl";
import Loader from "../../Loader";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import Select from 'react-select';
import formatDateTimeToPST from '../../PSTDateConvert';

const NO_PAGINATION_LIMIT = 10000;

const CallPassDisplayIdentityManageTn = () => {
  const navigate = useNavigate();
  const location = useLocation();
      
  const { initialFilters } = location.state || {};

  const [name, setName] = useState('');
  const [timeZone, seTimeZone] = useState('');
  const [token, setToken] = useState('');
  const [cid, setCid] = useState('');
  const [expire, setExpire] = useState('');  
  const [role, setRole] = useState('');
  const [access, setAccess] = useState([]);
  const [popupOpen, setPopupOpen] = useState(false);
  const [loadingCount, setLoadingCount] = useState(0);
  const [companies, setCompanies] = useState([]);
  const [callPassDisplayIdentitiesAccess, setCallPassDisplayIdentitiesAccess] = useState(false);
  const [userCallPassDisplayIdentitiesAccess, setUserCallPassDisplayIdentitiesAccess] = useState(false);

  const [tnNumbers, setTnNumbers] = useState([])
  const [displayIdentities, setDisplayIdentities] = useState([])
  const [displayIdentityDetails, setDisplayIdentityDetails] = useState({})
  
  const [selectedCompany, setSelectedCompany] = useState(initialFilters?.selectedCompany || "");
  const [selectedNumber, setSelectedNumber] = useState("");
  const [selectedAction, setSelectedAction] = useState("change");
  const [displayIdentityIndex, setDisplayIdentityIndex] = useState('')

  const [applyDisabled, setApplyDisabled] = useState(false);
  const [validationErrors, setValidationErrors] = useState({
    company: false,
    number: false,
    displayIdentityIndex: false,
  });

  const axiosJWT = axios.create();
 
  axiosJWT.interceptors.request.use(async (config) => {
    const currentDate = new Date();
    if (expire * 1000 < currentDate.getTime()) {
      const response = await axios.get(`${baseUrl}/token`);
      config.headers.Authorization = `Bearer ${response.data.accessToken}`;
      setToken(response.data.accessToken);
      const decoded = jwt_decode(response.data.accessToken);
      setName(decoded.name);
      seTimeZone(decoded.timezone);
      setRole(decoded.role)
      setExpire(decoded.exp);
      setCid(decoded.cid);
    }
    return config;
  }, (error) => {
    return Promise.reject(error);
  });

  useEffect(() => {
    refreshToken();
    getUserCompany();
  }, []);

  useEffect(() => {
    if(cid){
      checkPageAccess();
    }
  }, [cid]);

  const incrementLoading = () => setLoadingCount((prev) => prev + 1);
  const decrementLoading = () => setLoadingCount((prev) => Math.max(prev - 1, 0));

  useEffect(() => {
    setPopupOpen(loadingCount > 0);
  }, [loadingCount]);

  useEffect(() => {
    if(role >= 3 && cid){
      setSelectedCompany(cid);
    }
  }, [cid, role]);

  useEffect(() => {
    if(selectedCompany){
      fetchTnNumbers(selectedCompany);
      setSelectedNumber('')
      fetchDisplayIdentitiesData(1, selectedCompany);
    }
  },[selectedCompany])

  useEffect(() => {
    geTnNumberDisplayIdentityDetails(selectedNumber)
    setSelectedAction('change')
    setDisplayIdentityIndex('')
  },[selectedNumber])

  const refreshToken = async () => {
    try {
        const response = await axios.get(`${baseUrl}/token`);
        
        setToken(response.data.accessToken);
        const decoded = jwt_decode(response.data.accessToken);
        console.log(decoded);
        setName(decoded.name);
        seTimeZone(decoded.timezone);
        setRole(decoded.role)
        setExpire(decoded.exp);
        setCid(decoded.cid);
    } catch (error) {
        if (error.response) {
            // setError("Unauthorized");
            navigate("/");  
            window.location.reload();
        }
    }
  }

  const getUserCompany = async () => {
    
    const response = await axiosJWT.get(`${baseUrl}/active-user-company`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    const companyList = response.data.filter(item => item.id !== 1);
    // company.shift();
    // console.log(response.data);
    setCompanies(companyList);
  }

  const checkPageAccess = async () => {
    try {
        incrementLoading();
        // Fetch all required data            
        const customerDigitMappingResponse = await axios.get(`${baseUrl}/check-company-e911-access/${cid}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        const userAccessResponse = await axiosJWT.get(`${baseUrl}/user-access`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        
        const callPassDisplayIdentitiesSwitch = customerDigitMappingResponse.data.call_pass_display_identities_switch;
        const userCallPassDisplayIdentitiesSwitch = userAccessResponse.data.user_call_pass_display_identities_switch;
        decrementLoading();
        setAccess(userAccessResponse.data.results);
        // Conditional check for access
        if (
            callPassDisplayIdentitiesSwitch >= 2 &&
            userCallPassDisplayIdentitiesSwitch >= 2
        ) {
            setUserCallPassDisplayIdentitiesAccess(true);
            setCallPassDisplayIdentitiesAccess(true);
        } else if (
            callPassDisplayIdentitiesSwitch >= 1 &&
            userCallPassDisplayIdentitiesSwitch >= 1
        ) {
            navigate('/call-pass-display-identities');
        } else {
            navigate('/dashboard');
        }
    } catch (error) {
        console.error("Error checking page access:", error);
        navigate('/dashboard'); // Redirect in case of any error
    }
  };

  const fetchTnNumbers = async (selectedCompany) => {
    incrementLoading();
    try {
      const response = await axiosJWT.get(`${baseUrl}/get-call-passed-enabled-numbers`, {
        params: { 
          cid: selectedCompany,
          skipBcid: 1
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setTnNumbers(response.data);
    } catch (error) {
      console.error("Error fetching tn numbers:", error);
    } finally {
      decrementLoading();
    }
  }

  const fetchDisplayIdentitiesData = async (page, company) => {
    incrementLoading();
    try {
        const response = await axiosJWT.get(`${baseUrl}/call-pass-display-identities`, {
          params: { 
            page: 1,
            limit: NO_PAGINATION_LIMIT, 
            company: company,
          },
          headers: { Authorization: `Bearer ${token}` }
        });
        setDisplayIdentities(response.data.summary || []);
    } catch (error) {
        console.error("Error fetching summary data:", error);
        // Handle error
    } finally {
        decrementLoading();
    }
  };

  const geTnNumberDisplayIdentityDetails = async (tnNumber) => {
    incrementLoading();
    try {
      const response = await axiosJWT.get(`${baseUrl}/get-display-identity-by-tn`, {
        params: {
          tnNumber,
          cid: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setDisplayIdentityDetails(response.data);
    } catch (error) {
      console.error("Error fetching display identity details:", error);
    } finally {
      decrementLoading();
    }
  }

  const handleApplyChange = async (e) => {
    e.preventDefault();
    try {
      const newValidationErrors = {
        company: selectedCompany == '',
        number: selectedNumber == '',
        // dropdown only required when changing, not when removing
        displayIdentityIndex: selectedAction === 'change' && displayIdentityIndex == '',
      };
      setValidationErrors(newValidationErrors);
      const hasErrors = Object.values(newValidationErrors).some((error) => error);
  
      if(!hasErrors){
        setApplyDisabled(true)
        setPopupOpen(true)
  
        const displayIdentity = displayIdentities[displayIdentityIndex]
  
        const response = await axios.post(`${baseUrl}/change-tn-number-display-identity`,{
          cid: selectedCompany,
          tn: selectedNumber,
          operation: selectedAction,
          ...(selectedAction === 'change' && { dirid: displayIdentity.dirid }),
          ...(selectedAction === 'change' && { eid: displayIdentity.eid }),
        },{
          headers : {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }) 
  
        const responseData = response.data
  
        if (responseData.status) {
          alert(responseData.msg || 'Operation completed successfully');
          geTnNumberDisplayIdentityDetails(selectedNumber)
        } else {
          alert(responseData.msg || 'Operation failed');
        }
      }
    } catch (error) {
      console.error('Error changing the tn number display identity')
    } finally {
      setPopupOpen(false)
      setApplyDisabled(false)
      setDisplayIdentityIndex('')
    }
  }

  const gotoDisplayIdentitiesScreen = (e) => {
    e.preventDefault();
    const navigationState = {
        initialFilters: { // Current filter values from Summary page
            selectedCompany,
        }
    }
    navigate("/call-pass-display-identities", { state: navigationState });
  }

  return (
    <div className="panelbox">
      <Navbar  token={token} access = {access}/>
        <div className="right-panel">
          <Header name={name} />
          {popupOpen && <Loader/>}
          <div className="content-page">

            <div className="row">
              <div className="col-4">
                  <div className="left-title">
                      <h1>View/Edit TN - Call Pass Display Details</h1>
                  </div>
              </div>    
              <div className="col-8 inventory-btn">
                  <div className="addnew-button flex gap-2">                              
                      <a href='#' onClick={(e) => gotoDisplayIdentitiesScreen(e)}><span>&larr;</span>Back</a>
                  </div>
              </div>                     
            </div>

            <div className="common-white-shadow-background setting-section">
              <div className="row filter-section align-items-end">

                {role <=2 && (<div className="col-md-2">
                  <label>Company:</label>
                  <select value={selectedCompany} onChange={(e) => setSelectedCompany(e.target.value)} className="form-control">
                  <option value="" >Company</option>
                      {companies.map(option => (
                          <option key={option.id} value={option.id}>{option.cname}</option>
                      ))}
                  </select>
                </div>)}

                <div className='col-md-2'>
                  <label>Number:</label>
                  <Select
                    classNamePrefix="select"
                    name="number"
                    placeholder="Select Number"
                    className='search-select enrms-summary-tags'
                    onChange={(selectedOption)=>{
                      setSelectedNumber(selectedOption.value)
                    }}
                    value={
                      selectedNumber
                      ? { value: selectedNumber, label: selectedNumber }
                      : null   // 👈 Important: show placeholder when no selection
                    }
                    options={tnNumbers?.map(number => ({
                      value: number,
                      label: number                                               
                    }))}
                  />
                </div>

              </div>
            </div>

            {selectedCompany && selectedNumber && Object.keys(displayIdentityDetails).length > 0 && (
              <div className="common-white-shadow-background setting-section">
                <div className="row">
                  <div className=" setting-section haft-whitebox">
                    <div className="search-result-section">
                      <h3>Display Identity Details</h3>
                    </div>
                    {displayIdentityDetails.found ? (
                      <table className="tablebox search-result-table">
                        <thead>
                          <tr>
                            <th>TN</th>
                            <th>Entity Name</th>
                            <th>Display Identity</th>
                            <th>Logo</th>
                            <th>Call Reason</th>
                            <th>Created by</th>
                            <th>Created Date ({timeZone})</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{displayIdentityDetails.tn ?? displayIdentityDetails.TN ?? '-'}</td>
                            <td>{displayIdentityDetails.entity_name ?? '-'}</td>
                            <td>{displayIdentityDetails.display_name ?? '-'}</td>
                            <td>{displayIdentityDetails.logo ?? 'No logo'}</td>
                            <td>{displayIdentityDetails.call_reason ?? '-'}</td>
                            <td>{displayIdentityDetails.created_by ?? '-'}</td>
                            <td>{displayIdentityDetails.created_date ? formatDateTimeToPST(displayIdentityDetails.created_date, timeZone, role) : '-'}</td>
                          </tr>
                        </tbody>
                      </table>
                    ) : (
                      <p className="font-16 font-500 pt-5 leading-6">{displayIdentityDetails.message || 'Tn not mapped to any display identity'}</p>
                    )}
                  </div>
                </div>
              </div>
            )}

            {(selectedCompany && selectedNumber) && <div className="common-white-shadow-background setting-section">
              <div className="row">
                <h3 className='comapny-label'>Action</h3>
                <div className="settingbox radio-standard-box">
                  <label htmlFor="change">
                    <input 
                      type="radio" 
                      id="pastNumber"
                      name="operation"  
                      value={'change'} 
                      checked={selectedAction === 'change'} 
                      onChange={(e) => setSelectedAction(e.target.value)} 
                    />
                    Change Display Identity
                  </label>

                  {displayIdentityDetails.found && <label htmlFor="delete">
                    <input 
                      type="radio" 
                      id="pastNumber" 
                      name="operation"  
                      value={'delete'} 
                      checked={selectedAction === 'delete'} 
                      onChange={(e) => setSelectedAction(e.target.value)} 
                    />
                    Remove Display Identity
                  </label>}
                </div>
              </div>
            </div>}

            {(selectedNumber && selectedAction === 'change') && (<div className="common-white-shadow-background setting-section">
              <div className="row">
                  <h3 className='comapny-label'>Select Display Identity</h3>
                  <div className="inputbox">
                      <select name="" id=""  value={displayIdentityIndex} onChange={(e) => setDisplayIdentityIndex(e.target.value)}>
                          <option value="">Select Display Identity</option>
                          {displayIdentities.map((identity, index) => {
                              // #3: Exclude the Display Identity that the TN is already assigned to
                              if (displayIdentityDetails?.DIRID && displayIdentityDetails?.EID &&
                                  identity.dirid == displayIdentityDetails.DIRID && identity.eid == displayIdentityDetails.EID) {
                                return null;
                              }
                              return (
                                <option key={index} value={index}>
                                    {`${identity.entity_name ? identity.entity_name + ' - ' : ''}${identity.display_name}-${identity.call_reason}-${identity.logo}`}
                                </option>
                              );
                          })}
                      </select>
                  </div>
              </div>
              {validationErrors.displayIdentityIndex && <p className="error">Please select a value from the dropdown.</p>}
            </div>)}

            <div className="row footer-row">
              <a href="#" className={applyDisabled ? 'next disabled-link' : 'next'} onClick={handleApplyChange}>Apply</a>
            </div>
          </div>
        </div>
    </div>
  )
}

export default CallPassDisplayIdentityManageTn